import React, { useEffect, useState } from 'react';
import css from './AddNewRequest.module.css';

import * as requestServices from '../../../../services/requestServices';
import * as contractServices from '../../../../services/contractService';
import * as studentServices from '../../../../services/studentServices';
import * as programServices from '../../../../services/programServices.js';

function AddNewRequest({ data, onAdd, toggleModal }) {
    const [contractList, setContractList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [programList, setProgramList] = useState([]);
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [aircraftTypes, setAircraftTypes] = useState([]);
    const [programFilters, setProgramFilters] = useState([]);
    const [filteredPrograms, setFilteredPrograms] = useState([])

    useEffect(() => {
        contractServices
            .getOption('list')
            .then((result) => {
                setContractList((state) => result.data.sort((a, b) => b.contractId - a.contractId));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        studentServices
            .getOption('list')
            .then((result) => {
                setStudentList((state) => result.data.sort((a, b) => b.studentId - a.studentId));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    useEffect(() => {
        programServices
            .getOption('list')
            .then((result) => {
                setProgramList((state) => result.data);
                setAircraftTypes(result.data.map((x) => x.aircraftTypeTitleShort).filter(onlyUnique));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    let template = { contractId: 0, studentId: 0, programId: 0 };

    const [newData, setNewData] = useState(template);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
        console.log(newData);
        console.log(e.target.id);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(newData.programId) {

            requestServices
            .create(newData)
            .then((result) => {
                setNewData((prevData) => ({
                    ...prevData,
                    programId: 0,
                }));
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
            })
            .catch((err) => {
                console.log(err);
                setMessage((state) => ({ message: err.message, color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
            });
        } else {
            setMessage((state) => ({ message: 'You need to select program first', color: 'red' })); //check why colors are not changing
        }
    };
    console.log(message);

    const onlyUnique = (value, index, array) => {
        return array.indexOf(value) === index;
    };

    const handleFilterPrograms = (e) => {
        setNewData((prevData) => ({
            ...prevData,
            programId: 0,
        }));
        let id = e.currentTarget.id;

        let index = programFilters.indexOf(id);
        // console.log(index);
        if (index > -1) {
            setProgramFilters((st) => {
                st.splice(index, 1);
                setFilteredPrograms(programList.filter(x => st.includes(x.aircraftTypeTitleShort)))
                return st;
            });
        } else {
            setProgramFilters((st) => {
                st.push(id);
                setFilteredPrograms(programList.filter(x => st.includes(x.aircraftTypeTitleShort)))

                return st;
            });
        }
    };

    return (
        <div className={css.backdrop}>
            <div className={css.modal}>
                <form  className={css.form}>
                    <label htmlFor="contractId">Contract: </label>
                    <select id="contractId" onChange={handleChange} className={css.input} value={newData.contractId}>
                        <option key={'na'} value={0}>
                            Select contract ...
                        </option>
                        {contractList.map((x) => (
                            <option key={x.contractId} value={x.contractId}>
                                {x.contractTitle}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="studentId">Student: </label>
                    <select id="studentId" onChange={handleChange} className={css.input} value={newData.studentId}>
                        <option key={'na'} value={0}>
                            Select student ...
                        </option>
                        {studentList.map((x) => (
                            <option key={x.studentId} value={x.studentId}>
                                {x.studentName}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="programId">Program: </label>
                    <select id="programId" onChange={handleChange} className={css.input} value={newData.programId}>
                        <option key={'na'} value={0}>
                            Select program ...
                        </option>
                        {filteredPrograms.map((x) => (
                            <option key={x.programId} value={x.programId}>
                                {x.programTitleExt}
                            </option>
                        ))}
                    </select>
                    <div className={css.acTypesFilter}>
                        {aircraftTypes.map((x, i) => (
                            <div>
                                <input type="checkbox" key={i} id={x} onClick={handleFilterPrograms} />
                                <label htmlFor={x}>{x}</label>
                            </div>
                        ))}
                    </div>
                    

                    <button className={css.addButton} onClick={handleSubmit}>
                        Add request
                    </button>
                    <button onClick={toggleModal} className={css.cancelButton}>
                        Cancel
                    </button>
                    {/* Check why colors are not changing */}
                    <div style={{textAlign: 'center'}}>
                    <p className={css[message.color]}>{message.message}</p>

                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddNewRequest;
